import React from 'react';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { Box } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { ObjectNameLink, ObjectIcon, ObjectName } from './styled.tsx';

export type Props = {
	iconUrl: string;
	link: string;
	title: string;
	tooltip: string;
};

export const SidebarHeader = ({ iconUrl, link, title, tooltip }: Props) => (
	<Box data-testId="object-name-link">
		<ObjectNameLink target="_blank" href={link}>
			<ObjectIcon data-testId="object-name-icon">
				{/* Using a key set to the icon url prevents this image from being 
                        re-used and causing the old image to appear while the new one is loading */}
				<img src={iconUrl} key={iconUrl} alt="" />
			</ObjectIcon>
			<ObjectName>{title}</ObjectName>
			<Box data-testId="object-name-tooltip">
				<Tooltip content={tooltip}>
					<Box data-testId="object-name-shortcut-icon">
						<ShortcutIcon label="" />
					</Box>
				</Tooltip>
			</Box>
		</ObjectNameLink>
	</Box>
);
